/* eslint-disable react/jsx-curly-brace-presence */
import React from 'react'
import { Icon, Button, Label, Table, Popup } from 'semantic-ui-react'
import get from 'lodash/get'
import upperCase from 'lodash/upperCase'

import utils from '../../../../utils'
import colors from '../../../../assets/colors'

export default class PaymentCell extends React.PureComponent {
  onNoteClick = () => {
    const { readOnly, showEditNote } = this.props

    return !readOnly && showEditNote()
  }

  renderDynamicFees = () => {
    const { order } = this.props
    const dynamicFees = order.restaurant.branch.dynamic_fees

    if (dynamicFees) {
      const fees = Object.values(dynamicFees)
      const rows = []

      for (let i = 0; i < fees.length; i += 1) {
        const fee = fees[i]

        if (fee.type === 'FIXED') {
          rows.push(
            <div style={{ fontWeight: 'bold', margin: '3px 0px' }} key={fee.name}>
              {fee.name}:
              <span style={{ color: 'orange' }}>
                {` $${fee.fee_amount}`}
                <span style={{ color: 'gray' }}>
                  {` (${utils.order.convertToRiel(fee.fee_amount)} ៛)`}
                  {` (${fee.go_to.toUpperCase()})`}
                </span>
              </span>
            </div>
          )
        }
      }

      if (rows.length > 0)
        return (
          <React.Fragment>
            <hr style={{ margin: 0 }} />
            {rows}
          </React.Fragment>
        )
    }

    return null
  }

  renderVoucherDiscount = orderSummary => {
    const { order } = this.props
    const discountOn =
      get(order.voucher, 'voucher.metadata.discount_on') === 'delivery-fee' ? 'Delivery fee' : 'Order'

    const isDiscountVoucher = get(order.voucher, 'voucher.type') === 'DISCOUNT_VOUCHER'
    const promoIcon = isDiscountVoucher ? 'ticket' : 'gift'

    return (
      <React.Fragment>
        <hr style={{ margin: 0 }} />

        <div style={{ fontWeight: 'bold', margin: '3px 0px' }}>
          Promo Code:
          <Label size="small" style={{ marginLeft: 5 }}>
            <Icon name={promoIcon} />
            {order.voucher.voucher.code.toUpperCase()}
          </Label>
        </div>

        <div style={{ fontWeight: 'bold', margin: '3px 0px' }}>
          Discount on:
          <Label size="small" style={{ marginLeft: 5 }}>
            {discountOn}
          </Label>
        </div>

        <div style={{ fontWeight: 'bold', margin: '3px 0px' }}>
          Discount:
          <span style={{ color: 'orange' }}>
            {` $${orderSummary.voucherDiscount}`}
            <span style={{ color: 'gray' }}>{` (${utils.order.convertToRiel(
              orderSummary.voucherDiscount
            )} ៛)`}</span>
          </span>
        </div>

        <hr style={{ margin: 0 }} />
      </React.Fragment>
    )
  }

  renderDiscount = orderSummary => {
    const { order } = this.props
    const branchDiscountRate = get(order, 'restaurant.branch.discount.discount_rate', 0)

    return (
      <React.Fragment>
        <div style={{ fontWeight: 'bold', margin: '3px 0px' }}>
          Merchant Discount:
          <span style={{ color: 'orange' }}>
            {` $${orderSummary.merchantDiscount}`}
            <span style={{ color: 'gray' }}>
              {` (${utils.order.convertToRiel(orderSummary.merchantDiscount)} ៛)`}
              {` (${orderSummary.costSharing ? orderSummary.costSharing.merchant : branchDiscountRate}%)`}
            </span>
          </span>
        </div>

        {orderSummary.companyDiscount > 0 && (
          <div style={{ fontWeight: 'bold', margin: '3px 0px' }}>
            Company Discount:
            <span style={{ color: 'orange' }}>
              {` $${orderSummary.companyDiscount}`}
              <span style={{ color: 'gray' }}>
                {` (${utils.order.convertToRiel(orderSummary.companyDiscount)} ៛)`}
                {` (${orderSummary.costSharing ? orderSummary.costSharing.company : 0}%)`}
              </span>
            </span>
          </div>
        )}

        {order.voucher && this.renderVoucherDiscount(orderSummary)}
      </React.Fragment>
    )
  }

  renderVatDetail = orderSummary => {
    return (
      <React.Fragment>
        <div style={{ fontWeight: 'bold', margin: '3px 0px' }} key="restaurantVat">
          Order VAT:
          <span style={{ color: 'orange' }}>
            {` $${orderSummary.vatFee}`}
            <span style={{ color: 'gray' }}>
              {` (${utils.order.convertToRiel(orderSummary.vatFee)} ៛)`}
              {` (${orderSummary.vatRate}%)`}
            </span>
          </span>
        </div>
      </React.Fragment>
    )
  }

  renderPaymentDetail = orderSummary => {
    const { order } = this.props
    const isHasVat = order.restaurant.vat > 0
    const distance = get(order, 'etaInfo.info.legs.0.distance.value', 0)
    const merchantSettlementType = orderSummary.merchantSettlementType === 'full' ? 'Full' : ''
    const orderStatus = get(order, 'status', 'pending')

    const { customerGrandTotal } = orderSummary
    const paidOnline = order.payment_gateway

    const isPaidOnlineOrderModified = paidOnline && paidOnline.amount !== customerGrandTotal
    const isPaidOnlineOrderRejected = paidOnline && orderStatus === 'rejected'

    let adjustedAmount = 0
    let amountFor = ''

    if (isPaidOnlineOrderModified) {
      const amount = customerGrandTotal - paidOnline.amount

      adjustedAmount = Math.abs(Number(amount).toFixed(2))
      amountFor = amount > 0 ? 'Extra Order Amount' : 'Refund Amount'
    }

    if (isPaidOnlineOrderRejected) {
      const {amount} = paidOnline

      adjustedAmount = Math.abs(Number(amount).toFixed(2))
      amountFor = 'Refund Amount'
    }

    return (
      <React.Fragment>
        <div style={{ fontWeight: 'bold', margin: '3px 0px' }}>
          Merchant Total:
          <span style={{ color: 'rgba(208, 62, 62, 1)' }}>
            {` $${orderSummary.merchantGrandTotal}`}
            <span style={{ color: 'gray' }}>{` (${utils.order.convertToRiel(
              orderSummary.merchantGrandTotal
            )} ៛)`}</span>
          </span>
        </div>

        <div style={{ fontWeight: 'bold', margin: '3px 0px' }}>
          Merchant Commission:
          <span style={{ color: 'orange' }}>
            {` $${orderSummary.commissionFee}`}
            <span style={{ color: 'gray' }}>
              {` (${utils.order.convertToRiel(orderSummary.commissionFee)} ៛)`}
              {` (${order.discount_rate}% ${merchantSettlementType})`}
            </span>
          </span>
        </div>
        {this.renderDiscount(orderSummary)}
        {isHasVat && this.renderVatDetail(orderSummary)}

        <div style={{ fontWeight: 'bold', margin: '3px 0px' }}>
          Delivery:
          <span style={{ color: 'green' }}>
            {` $${order.delivery_fee}`}
            <span style={{ color: 'gray' }}>
              {` (${utils.order.convertToRiel(order.delivery_fee, 4000)} ៛)`}
              {` (${distance} m)`}
            </span>
          </span>
        </div>

        {orderSummary.deliveryDiscount > 0 ? (
          <div style={{ fontWeight: 'bold', margin: '3px 0px' }}>
            Delivery Discount:
            <span style={{ color: 'orange' }}>
              {` $${orderSummary.deliveryDiscount}`}
              <span style={{ color: 'gray' }}>
                {` (${utils.order.convertToRiel(orderSummary.deliveryDiscount)} ៛)`}
              </span>
            </span>
          </div>
        ) : null}
        {this.renderDynamicFees()}

        {isPaidOnlineOrderModified || isPaidOnlineOrderRejected ? (
          <div style={{ fontWeight: 'bold', margin: '3px 0px' }}>
            {amountFor}:
            <span style={{ color: 'rgba(208, 62, 62, 1)' }}>
              {` $${adjustedAmount}`}
              <span style={{ color: 'gray' }}>
                {` (${utils.order.convertToRiel(adjustedAmount)} ៛)`}
              </span>
            </span>
          </div>
        ) : null}
        {
          order.refund_to ? (
          <div style={{ fontWeight: 'bold', margin: '3px 0px' }}>
            Refund To:
            <span>
              {` ${upperCase(order.refund_to)}`}
            </span>
          </div>
        ) : null
        }

        {order.refund_note ? (
          <div style={{ fontWeight: 'bold', margin: '3px 0px' }}>
            Refund Note:
            <span>
              {' '}{order.refund_note}
            </span>
          </div>
        ) : null
        }
      </React.Fragment>
    )
  }

  renderPaymentTrigger = orderSummary => {
    const { order } = this.props
    const isMarkUp = Number(get(order, 'restaurant.mark_up_percentage', 0)) > 0

    return (
      <div>
        <div style={{ fontWeight: 'bold', margin: '3px 0px' }}>
          Merchant Subtotal:
          <br />
          <span style={{ color: 'rgba(208, 62, 62, 1)' }}>
            {` $${orderSummary.subTotal}`}
            <br />
            <span style={{ color: 'gray' }}>{`(${utils.order.convertToRiel(orderSummary.subTotal)} ៛)`}</span>
          </span>
        </div>

        <div style={{ fontWeight: 'bold', margin: '3px 0px' }}>
          Customer Total:
          {isMarkUp ? (
            <div>
              <br />
              {'(Mark up)'}
            </div>
          ) : null}
          <br />
          <span style={{ color: 'rgba(208, 62, 62, 1)' }}>
            {` $${orderSummary.customerGrandTotal}`}
            <br />
            <span style={{ color: 'gray' }}>{`(${utils.order.convertToRiel(
              orderSummary.customerGrandTotal
            )} ៛)`}</span>
          </span>
        </div>
      </div>
    )
  }

  renderPaymentSummary = () => {
    const { order } = this.props
    const orderSummary = utils.order.getOrderSummary(order)

    return (
      <Popup trigger={this.renderPaymentTrigger(orderSummary)} wide position="top center">
        {this.renderPaymentDetail(orderSummary)}
      </Popup>
    )
  }

  render() {
    const { order } = this.props
    const isHasPromoCode = order.voucher
    const isHasVat = order.restaurant.vat > 0
    const isHasNote = (order.note || '').length > 0
    const color = isHasNote ? { color: 'green' } : {}

    return (
      <Table.Cell textAlign="center">
        {isHasPromoCode && (
          <Label color="green" style={{ margin: 0, width: 100, marginBottom: 3 }}>
            Promo Code
          </Label>
        )}

        {order.payment_gateway && (
          <Popup
            wide
            position="top center"
            trigger={
              <Label
                style={{
                  margin: 0,
                  width: 100,
                  marginBottom: 3,
                  color: colors.black,
                  backgroundColor: colors.yellow,
                }}
              >
                Paid Online
              </Label>
            }
          >
            {order.payment_gateway.provider}
          </Popup>
        )}

        {this.renderPaymentSummary()}
        {isHasVat && <div style={{ fontSize: 12, color: 'darkgray' }}>{'(incl VAT)'}</div>}

        <Popup
          wide
          position="top center"
          trigger={
            <Button
              {...color}
              size="mini"
              icon="pencil"
              content="Note"
              labelPosition="right"
              onClick={this.onNoteClick}
              style={{ margin: 0, width: 100, marginTop: 5 }}
            />
          }
        >
          {order.note || 'No delivery note'}
        </Popup>
      </Table.Cell>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/orders/components/OrderListItem/PaymentCell.js